import { CoordinateManager } from '../../../../../coordinate-manager';
import { RevertChange } from '../../../../../elements/design/design-node/design-node';
import { DesignTool } from '../../../../design-tool';

export function repositionDesign(
  tool: DesignTool,
  newEasting: number,
  newNorthing: number,
): RevertChange {
  const projectPosition = CoordinateManager.getInstance().localToProject(
    tool.asset.position.x,
    tool.asset.position.y,
  );
  const wgsBefore = CoordinateManager.getInstance().convertFromProject(
    projectPosition.x,
    projectPosition.y,
    'wgs84',
  );
  const wgsAfter = CoordinateManager.getInstance().convertFromProject(
    newEasting,
    newNorthing,
    'wgs84',
  );

  tool.asset.wgs84 = {
    lat: wgsAfter.y,
    lng: wgsAfter.x,
  };
  tool.asset.calculateLocalPosition();
  tool.asset.updateMatrixWorld(true);

  return {
    type: 'custom',
    callback: () => {
      tool.asset.wgs84 = {
        lat: wgsBefore.y,
        lng: wgsBefore.x,
      };
      tool.asset.calculateLocalPosition();
      tool.asset.updateMatrixWorld(true);
    },
  };
}
